module.exports = __webpack_public_path__ + "img/itx-file-type-xls.8d65ab92.svg";